<div class="field">
  <ng-content select="label"></ng-content>
  <div class="field__in">
    <div class="field__input">
      <ng-content select="content-prefix"></ng-content>
      <ng-content select="input"></ng-content>
      <ng-content select="textarea"></ng-content>
      <ng-content select="app-combobox"></ng-content>
      <ng-content select="app-select"></ng-content>
      <ng-content select="app-select-multiple"></ng-content>
      <ng-content select="app-date-time-picker"></ng-content>
      <ng-content select="content-block"></ng-content>
    </div>
  </div>
</div>
